import { defineMessages } from 'react-intl';

export default defineMessages({
    verifyYourAddress: {
        id: 'ml-components-address-react.verifyAddress.Verify your address',
        defaultMessage: 'Verify your address'
    },
    useThisAddress: {
        id: 'ml-components-address-react.verifyAddress.USE THIS ADDRESS',
        defaultMessage: 'USE THIS ADDRESS'
    },
    continue: {
        id: 'ml-components-address-react.verifyAddress.CONTINUE',
        defaultMessage: 'CONTINUE'
    },
    editAddress: {
        id: 'ml-components-address-react.verifyAddress.EDIT ADDRESS',
        defaultMessage: 'EDIT ADDRESS'
    },
    multipleAddresses: {
        id: 'ml-components-address-react.verifyAddress.Additional matches were found for the address you entered. Please choose the one you want to use and click CONTINUE.',
        defaultMessage: 'Additional matches were found for the address you entered. Please choose the one you want to use and click CONTINUE.'
    },
    manuallyChanged: {
        id: 'ml-components-address-react.verifyAddress.Address information has been updated. Please choose the address you want to use and click CONTINUE.',
        defaultMessage: 'Address information has been updated. Please choose the address you want to use and click CONTINUE.'
    },
    unableToValidate: {
        id: 'ml-components-address-react.verifyAddress.We were unable to verify your address through the US Postal Service. Do you want to edit this address?',
        defaultMessage: 'We were unable to verify your address through the US Postal Service. Do you want to edit this address?'
    },
    chooseAddress: {
        id: 'ml-components-address-react.verifyAddress.Choose Address',
        defaultMessage: 'Choose Address'
    },
    insuredAddress: {
        id: 'ml-components-address-react.verifyAddress.Insured Address',
        defaultMessage: 'Insured Address'
    },
    insuredResidence: {
        id: 'ml-components-address-react.verifyAddress.Insured Residence',
        defaultMessage: 'Insured Residence'
    }
});
